var magicStyles = [".date[data-v-7c12675a] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.day[data-v-7c12675a],\n.month[data-v-7c12675a] {\n  flex-basis: calc(((100% - 16px) * 0.3) + -0.8px);\n  flex-grow: 0;\n}\n.year[data-v-7c12675a] {\n  flex-basis: calc(((100% - 16px) * 0.4) + 1.6px);\n  flex-grow: 0;\n}"];

export default magicStyles;
